import api from './api';

/**
 * Consultar un documento SUNAT: descarga el XML vía Factiliza y lo parsea.
 * @param {{ supplier_id: number|string, document_type: string, series: string, number: string, issue_date: string }} payload
 * @returns {Promise<{ success: boolean, data?: { document_type: string, supplier_ruc: string, supplier_name: string, series: string, number: string, issue_date: string, currency: string, base_imponible: number, igv: number, total: number, products: Array<{ line_number: string, internal_code: string, description: string, quantity: number, unit_price: number, unit_code: string, total: number }>, notes: string }, message?: string }>}
 */
export async function fetchSunatDocument(payload) {
  const response = await api.post('/sunat/fetch-document', payload);
  return response.data;
}

export default { fetchSunatDocument };
